module.exports = "/static/assets/2737cd28da062447446bc93240e17270.png";